export const fetchCarts = async ({
    BeURL,
    page = 1,
    limit = 10,
    ...filters
}) => {
    try {

        /* 🔥 BUILD QUERY STRING */
        const params = new URLSearchParams({
            page,
            limit,
            ...filters
        }).toString();

        const res = await fetch(
            `${BeURL}/fetch-carts?${params}`,
            { credentials: "include" }
        );

        const data = await res.json();

        if (!data.success) {
            console.error(data.message || "Failed to fetch carts.");
            return null;
        }

        return data;

    } catch (err) {
        console.error("Error fetching carts:", err);
        return null;
    }
};